// src/components/EpinephrineTimer.js
import React, { useState, useEffect } from 'react';

export default function EpinephrineTimer({ isCPR }) {
    const [epiCount, setEpiCount] = useState(() => {
        const savedCount = localStorage.getItem('epiCount');
        return savedCount ? parseInt(savedCount, 10) : 0;
    });

    useEffect(() => {
        let interval = null;
        if (isCPR) {
            interval = setInterval(() => {
                setEpiCount(prev => {
                    const newCount = prev < 4 ? prev + 1 : prev;
                    localStorage.setItem('epiCount', newCount);
                    return newCount;
                });
            }, 120000); // 2 minutes
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isCPR]);

    return (
        <div className="epinephrine-timer">
            <h2>Epinephrine Timer</h2>
            <p>{epiCount < 4 ? `Next dose in: ${120 - (epiCount * 30)} seconds` : 'Max doses given'}</p>
        </div>
    );
}